import { Component } from '@poa/core';
import React from 'react';
import Spinner from 'react-spinkit';
import { observable, Observer } from '@poa/state';

const placeholederImage = require('../../img/placeholder_man.jpg');


class ChatsUserSidebar extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa
    t; // injected by Poa

    localState = observable({
        activeIdx: null,
        users_list: []
    });

    componentDidMount() {
        this.localState.users_list = this.store.chats.users_list;
    }

    handleListItemClick = (id) => {
        this.store.chats.selectedUserId = id;
        this.localState.activeIdx = id;
        this.actions.chatsActions.fetchMsgs({ 
            account_id: this.store.chats.selectedAccountId, 
            cred_id: this.store.chats.selected_cred_id.value,
            user_id: id
        });
    }


    render() {
        return (
            <>
                <div className='chats-page__container-sidebar'>
                    <div className='general_sidebar-header' style={{ overflowY: 'visible' }}>
                        <div className='general_sidebar-header__search'>
                            <div className='search__input input'>
                                USERS
                            </div>
                        </div>
                    </div>
                    <Observer>
                        {() => (
                            this.store.chats.users_meta.isLoading ? (
                                <div className="spinner-loading" style={{ paddingTop: '75px', textAlign: 'center' }}>
                                    <Spinner name="folding-cube" fadeIn="none" />
                                </div>
                            ) :
                                this.store.chats.users_meta.hasError ? (
                                    <div className="spinner-loading" style={{ paddingTop: '75px', textAlign: 'center' }}>
                                        <h1>Error occured</h1>
                                    </div>
                                ) :
                                    <div className='general_sidebar_content__list'>
                                        {
                                            this.localState.users_list.map((item, index) => (
                                                <div key={index}>
                                                    <div className={`general_sidebar_content__list__info_item${this.localState.activeIdx === item.id ? ' active' : ''}`}
                                                        onClick={() => this.handleListItemClick(item.id)}>
                                                        <div
                                                            key={item.id}
                                                            className='general_sidebar_content__list__info_item__grid_item'
                                                            style={{
                                                                gridTemplateColumns: "0.5fr 2fr 1fr"
                                                            }}>
                                                            <img
                                                                style={{
                                                                    position: 'relative',
                                                                    display: 'block',
                                                                    height: '30px',
                                                                    width: '30px',
                                                                    borderRadius: '50%',
                                                                    overflow: 'hidden',
                                                                    marginRight: '10px'
                                                                }}
                                                                src={placeholederImage}
                                                                onError={(e) => { e.target.src = placeholederImage; }}
                                                                alt=''
                                                            />

                                                            <div className='general_sidebar_content__list__info_item__grid_item__name'>
                                                                {item.nick ? item.nick : item.name}
                                                            </div>
                                                            <div className='general_sidebar_content__list__info_item__grid_item__total'>
                                                                {item.id}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                        )}
                    </Observer>

                </div>

            </>
        );
    }
}

export default Component({ namespaces: ['chats-user-sidebar'] })(ChatsUserSidebar);
